import runQuery from 'lib/resource/lib/helpers/run-query';
import trackOperation from './track-operation';

export default function runOperation(query, operationIdentifier, payload, ...rest) {
  return dispatch => {
    if (!operationIdentifier) {
      return Promise.reject(new Error(`Missing operation identifier for ${query}.`));
    }

    const operationId = `${query}#${operationIdentifier}`;
    const operation = runQuery(query, payload, ...rest).catch(result => {
      throw result.error;
    });

    return dispatch(trackOperation(operation, operationId));
  };
}
